import * as React from "react";
import { formatRelativeDates, useInterval } from "..";
export const FormatRelativeDates = React.memo(({ start }) => {
    const [state, setState] = React.useState(formatRelativeDates(start));
    useInterval(() => {
        const next = formatRelativeDates(start);
        if (next !== state) {
            setState(next);
        }
    }, 500);
    return React.createElement("span", null, state);
});
//# sourceMappingURL=FormatRelativeDates.js.map